import React, { useMemo } from 'react';
import { useLoadContractScreens } from '../../hooks/useLoadContractScreens';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import ActiveContractItem from '../ActiveContractItem/ActiveContractItem';
import { useLoadActiveCyclesWIthoutScreen } from './hooks/useLoadActiveCyclesWIthoutScreen';
import filterCyclesByContract from '../../utils/getCyclesByContract';
import { useAppSelector } from '../../../../store/store';
import FaultedCyclesButton from '../../../../components/FaultedCyclesButton/FaultedCyclesButton';

const ActiveContractCyclesList: React.FC = () => {
  const {
    contracts,
    screens,
    isLoading: isLoadingContractData,
    onDeleteScreen,
  } = useLoadContractScreens({ tabNumber: TAB_NUMBER.ACTIVE });
  const { cycles, isLoading } = useLoadActiveCyclesWIthoutScreen();
  const activeScreensCycles = useAppSelector((state) => state.cycles.activeScreensCycles);
  const allActiveCycles = useMemo(
    () => [...screens.flatMap((screen) => activeScreensCycles[screen.id] ?? []), ...cycles],
    [screens, activeScreensCycles, cycles],
  );
  let anyContractPending = true;
  const [contractsPending, setContractsPending] = React.useState<Record<string, boolean>>({});

  const onDecisionStateChange = (contractId: string, isPending: boolean) => {
    setContractsPending((prev) => {
      if (prev[contractId] === isPending) return prev;
      return { ...prev, [contractId]: isPending };
    });
  };

  if (isLoadingContractData) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!contracts.length && !isLoadingContractData) {
    return null;
  }

  anyContractPending = Object.values(contractsPending).some(Boolean);

  return (
    <>
      <FaultedCyclesButton cycles={allActiveCycles} />
      <ul className="c-active-contract-cycles-list pb-1">
        {anyContractPending && (
          <div className="flex flex-row items-center justify-center">
            <SpinnerLoader />
          </div>
        )}
        <div className={`flex flex-col gap-y-1 ${anyContractPending ? 'hidden' : ''}`}>
          {contracts.map((contract) => (
            <ActiveContractItem
              contractId={contract.id}
              contractName={contract.name}
              contractIsCelsius={contract.isCelsius}
              screens={screens}
              onDeleteScreen={onDeleteScreen}
              isLoading={isLoading}
              cyclesWithoutScreens={filterCyclesByContract(cycles, contract.id)}
              onDecisionStateChange={onDecisionStateChange}
              key={contract.id}
            />
          ))}
        </div>
      </ul>
    </>
  );
};

export default ActiveContractCyclesList;
